import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
// Models
import IPropertyOwnership from "models/PropertyOwnership";
// components
import Title from 'components/Title';
import PropertyOwnershipCard from "../../components/PropertyOwnershipCard";
import PropertyOwnershipCardSkeleton from "components/PropertyOwnershipCard.skeleton";
// mui
import { makeStyles } from "@mui/styles";
import { Box, Button } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
// Utilities
import { getContent } from 'utilities/Utilities';

type Props = {
  topGroup?: IPropertyOwnership[],
}

const TopProperties:React.FC<Props> = ({ topGroup }) => {
  const classes = useStyles();

  const [countCard, setCountCard] = useState<number>(window.innerWidth >= 1900 ? 4 : window.innerWidth >= 1240 ? 3 :  window.innerWidth >= 720 ? 2.2 : window.innerWidth >= 600 ? 1.6 : 1.2);

  const handlerScreenWidth = () => {
    setCountCard(window.innerWidth >= 1900 ? 4 : window.innerWidth >= 1240 ? 3 :  window.innerWidth >= 720 ? 2.2 : window.innerWidth >= 600 ? 1.6 : 1.2);
  }

  useEffect(() => {
    window.addEventListener('resize', handlerScreenWidth);

    return () => {
      window.removeEventListener('resize', handlerScreenWidth);
    }
  }, []);

  return (
    <Box className={classes.block}>
      <div className="big-container">
        <Box className={classes.header}>
          <Title>{getContent('homePage').topProperties}</Title>
          <Button endIcon={<ArrowForwardIcon />} component={NavLink} to="timeshares">
            View all
          </Button>
        </Box>
        <Swiper
          style={{ padding: '35px 5px' }}
          spaceBetween={24}
          slidesPerView={countCard}
        >
          {topGroup ? (
            topGroup.map((ownership: IPropertyOwnership) => (
              <SwiperSlide key={ownership.id}>
                <PropertyOwnershipCard propertyOwnership={ownership} />
              </SwiperSlide>
            ))
          ) : (
            [1,2,3,4].map(item => (
              <SwiperSlide key={item}>
                <PropertyOwnershipCardSkeleton />
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
    </Box>
  )
}

export default TopProperties;

const useStyles = makeStyles({
  block: {
    padding: '21px 0 16px 16px',
    backgroundColor: '#f5f6f7',
    '@media (min-width: 600px)': {
      padding: '37px 0 32px 32px',
    },
    '@media (min-width: 1240px)': {
      padding: '64px 0',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    aliginItems: 'center',
    paddingRight: '16px',
    '@media (min-width: 600px)': {
      paddingRight: '32px',
    },
    '@media (min-width: 1240px)': {
      paddingRight: 0,
    },
  },
});
